function serialize(value: unknown): string {
  return JSON.stringify(value);
}

function deserialize<T>(raw: string): T | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  if (trimmed === 'true') return true as unknown as T;
  if (trimmed === 'false') return false as unknown as T;
  if (trimmed === 'null') return null;

  // Parse valid JSON primitives (number/string/object/array) to preserve round-trip types.
  // If this isn't valid JSON, keep the raw string for backward compatibility.
  try {
    return JSON.parse(trimmed) as T;
  } catch {
    return trimmed as unknown as T;
  }
}

export { serialize, deserialize };

